<template>
  <section class="invoice-preview-wrapper">
    <div class="d-flex justify-content-center mb-1">
      <b-spinner
        variant="success"
        label="Spinning"
        block
        v-if="loadingInvoice"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>
    <b-row class="invoice-preview" v-if="!loadingInvoice">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="9" md="8">
        <b-card
          no-body
          class="invoice-preview-card px-2"
          id="invoice-preview-card"
        >
          <!-- Header -->
          <b-card-body class="">
            <div class="row align-items-center mb-2">
              <div class="col-md-1 col-1">
                <Logo />
              </div>
              <div class="col-md-9 col-9">
                <div class="">
                  <CompanyName />
                </div>
                <div class="">
                  <Address />
                </div>
              </div>
            </div>

            <div class="row">
              <div v-if="this.vat" class="col-12">
                <h4 class="mb-1 text-center">
                  {{ this.vat && !this.hideVAT ? "VAT " : "" }}
                  INVOICE
                </h4>
              </div>

              <div class="col-6 xl-6">
                <!-- Header: Left Content -->

                <div>
                  <h4 class="mb-1">Customer</h4>

                  <ClientAddress :client="whenSelected" />
                  <!-- Selected Client -->
                </div>
              </div>
              <div class="col-6 text-right">
                <!-- Header: Right Content -->
                <h4 >
                  Invoice No
                  <span class="invoice-number">#{{ invoiceId.invoiceNo }}</span>
                </h4>

                <div class="text-right">
                  <div class="row invoice-date-wrapper justify-content-end">
                    <div class="col-md-7 col-7 d-flex justify-content-end">
                      <p class="title">Issue Date:</p>
                    </div>
                    <div class="col-md-5 col-5 d-flex justify-content-end">
                      <!-- <b-form-input
                        id="createdOn"
                        type="text"
                        v-model="issuedDate"
                      /> -->
                      <flat-pickr v-model="invoiceId.createdOn" class="form-control invoice-edit-input" disabled />
                      <!-- <flat-pickr
                        v-model="invoiceId.createdOn"
                        class="form-control invoice-edit-input"
                        :config="{
                          minDate: issuedDate,
                        }"
                      />
                       -->
                    </div>
                  </div>

                  <div class="row invoice-date-wrapper">
                    <div class="col-md-7 col-7 d-flex justify-content-end">
                      <p class="title">Due Date:</p>
                    </div>
                    <div class="col-md-5 col-5 d-flex justify-content-end ">
                      <!-- <b-form-input
                        id="createdOn"
                        type="text"
                        v-model="dueDate"
                        disabled
                      /> -->
                      <flat-pickr
                      v-model="invoiceId.dueDate"
                      class="form-control invoice-edit-input"
                      disabled
                    />
                    </div>
                  </div>

                  <div
                    v-if="this.vat && !this.hideVAT"
                    class="row invoice-date-wrapper"
                  >
                    <div class="col-md-7 col-7  justify-content-md-end">
                      <p class="title">VAT Number:</p>
                    </div>
                    <div class="col-md-5 col-5  justify-content-md-end">
                      <p class="invoice-date">
                        {{ this.vat }}
                      </p>
                    </div>
                  </div>

                  <div
                    v-if="this.vat && !this.hideVAT"
                    class="row invoice-date-wrapper"
                  >
                    <div class="col-md-7 col-7  justify-content-md-end">
                      <p class="invoice-date-title">BRN Number:</p>
                    </div>
                    <div class="col-md-5 col-5  justify-content-md-end">
                      <p class="invoice-date">
                        {{ this.brn }}
                      </p>
                    </div>
                  </div>

                  <div
                    v-if="isFieldChosen('SalesRep')"
                    class="row invoice-date-wrapper"
                  >
                    <div
                      class="col-md-6 col-6 d-flex justify-content-md-end flex-grow-1"
                    >
                      <p class="invoice-date-title">Salesperson:</p>
                    </div>
                    <div class="col-md-6 col-6">
                      <p class="invoice-date">
                        {{ this.genSP }}
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="invoiceId.currency && invoiceId.currency != 'MUR'"
                    class="row invoice-date-wrapper"
                  >
                    <div
                      class="col-md-6 col-6 d-flex justify-content-md-end flex-grow-1"
                    >
                      <p class="invoice-date-title">
                        Rate ({{ this.invoiceId.currency }}):
                      </p>
                    </div>
                    <div class="col-md-6 col-6">
                      <p class="invoice-date">
                        {{ invoiceId.rate }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"></div> -->
          </b-card-body>

          <!-- Spacer -->
          <!-- <hr class="invoice-spacing" /> -->

          <!-- Invoice Description: Table -->
          <b-card-body>
            <div class="mt-3">
              <b-table
                bordered
                responsive
                :items="invoiceId.invoiceItem"
                :fields="dynamicFields"
              >
                <template #cell(productImg)="data">
                  <template v-if="data.item.itemId">
                    <img
                      :src="`${baseUrl}selfservices/getproductimage?ProductID=${data.item.itemId}`"
                      alt="Product Image"
                      style="width: 75px; height: 75px; object-fit: cover"
                      @error="showNoImage($event)"
                    />
                  </template>
                  <template v-else>
                    <span>-</span>
                  </template>
                </template>

                <template #cell(cost)="data">
                  {{ currencySymbol }}
                  {{
                    (
                      data.item.cost * data.item.quantity -
                      (data.item.discount === null ? 0 : data.item.discount)
                    ).toFixed(2)
                  }}
                </template>
                <template #cell(discount)="data">
                  {{ currencySymbol }}
                  {{
                    (data.item.discount === null
                      ? 0
                      : data.item.discount
                    ).toFixed(2)
                  }}
                </template>
              </b-table>
            </div>
          </b-card-body>

          <!-- Invoice Description: Total -->
          <b-card-body class="">
            <b-row>
              <!-- Col: Sales Persion -->
              <b-col cols="12" md="6" class="mt-md-0 mt-3">
                <span v-if="isFieldChosen('Notes')" class="font-weight-bold"
                  >Note:
                </span>
                <span v-if="isFieldChosen('Notes')">{{ invoiceId.notes }}</span>
                <!-- <b-card-text class="mb-0">
                  <span class="font-weight-bold">Salesperson:</span>
                  <span class="ml-75">{{ this.genSP }} </span>
                </b-card-text> -->
              </b-col>

              <!-- Col: Total -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-6 d-flex justify-content-end"
              >
                <div class="invoice-total-wrapper">
                  <div class="invoice-total-item" v-if="invoiceId.discount > 0">
                    <p class="invoice-total-title">Discount:</p>
                    <p class="invoice-total-amount">
                      {{ currencySymbol }}
                      {{
                        invoiceId.discount == null
                          ? 0.0
                          : invoiceId.discount.toFixed(2)
                      }}
                    </p>
                  </div>

                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Subtotal:</p>
                    <p class="invoice-total-amount">
                      {{ currencySymbol }}
                      {{ parseFloat(invoiceId.subTotal).toFixed(2) }}
                    </p>
                  </div>
                  <div
                    v-if="this.vat && !this.hideVAT"
                    class="invoice-total-item"
                  >
                    <p class="invoice-total-title">VAT:</p>
                    <p class="invoice-total-amount">
                      {{ currencySymbol }}
                      {{ parseFloat(invoiceId.tax).toFixed(2) }}
                    </p>
                  </div>

                  <hr class="my-50" />
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Total:</p>
                    <p class="invoice-total-amount">
                      {{ currencySymbol }}
                      {{ getTotal }}
                    </p>
                  </div>
                  <div class="invoice-total-item" v-if="payments.totalPaid > 0">
                    <p class="invoice-total-title">Total Paid:</p>
                    <p class="invoice-total-amount">
                      {{ currencySymbol }} {{ payments.totalPaid.toFixed(2) }}
                    </p>
                  </div>
                  <div class="invoice-total-item" v-if="payments.totalPaid > 0">
                    <p class="invoice-total-title">Balance:</p>
                    <p class="invoice-total-amount">
                      {{ currencySymbol }} {{ payments.balance.toFixed(2) }}
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <b-card
            v-if="
              isFieldChosen('PaymentTerms') &&
              payments.payments &&
              payments.payments.length > 0
            "
            class="no-margin-body"
            title="Payments"
          >
            <b-card-body>
              <b-table
                responsive
                class="table-payment"
                v-if="payments.payments && payments.payments.length > 0"
                :items="payments.payments"
                :fields="[
                  { key: 'settlementDate', label: 'Settlement Date' },
                  { key: 'reference', label: 'Reference' },
                  { key: 'amountPaid', label: 'Amount Paid' },
                ]"
              >
                <template #cell(Delete)="data">
                  <b-button
                    @click="deletePayment(data.id)"
                    variant="outline-danger"
                  >
                    <feather-icon icon="DeleteIcon" />
                  </b-button>
                </template>

                <template #cell(settlementDate)="data">
                  {{ beautifyDate(data.item.settlementDate) }}
                </template>

                <template #cell(amountPaid)="data">
                  {{ currencySymbol }} {{ data.item.amountPaid.toFixed(2) }}
                </template>
              </b-table>
            </b-card-body>
          </b-card>
          <b-card
            v-if="deliverynotes.length > 0"
            class=""
            title="Delivery Notes"
          >
            <b-table
              responsive
              bordered
              class="table-delivery"
              :items="deliverynotes"
              :fields="[
                { key: 'product', label: 'Product' },
                {
                  key: 'deliveryDate',
                  label: 'Delivery Date',
                  formatter: beautifyDate,
                },
                { key: 'quantity', label: 'quantity' },
                { key: 'note', label: 'Note' },
                { key: 'comment', label: 'Comment' },
                { key: 'status', label: 'Status' },
                { key: 'signature', label: 'Signature' },
              ]"
            >
              <template #cell(productImg)="data">
                <b-avatar :src="data.value" />
              </template>

              <template #cell(product)="data">
                <span> {{ getProductName(data.item.itemId) }}</span>
              </template>
<!-- 
              <template #cell(status)="data">
                {{ getStatus(data.item.itemId) }}
              </template> -->

              <template #cell(signature)="data">
                <b-button
                  v-if="data.item.signature != null"
                  variant="primary"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  @click="viewSignature(data.item.id)"
                >
                  Signature
                </b-button>

                <!-- <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="primary"
                  class="mb-75"
                  block
                  v-else
                  @click="showSignaturePad"
                >
                  Signature
                </b-button> -->
              </template>
            </b-table>
          </b-card>
          <!-- <div class="row">
            <div class="col-4">
              <h4 class="mb-4 text-center">Received By:</h4>

              <input type="text" id="signature" />
            </div>
            <div class="col-4">
              <h4 class="mb-4 text-center">Signature:</h4>

              <input type="text" id="signature" />
            </div>
            <div class="col-4">
              <h4 class="mb-4 text-center">Date:</h4>

              <input type="text" id="signature" />
            </div>
          </div> -->
        </b-card>
      </b-col>

      <!-- Right Col: Card -->
      <b-col cols="12" md="4" xl="3" class="invoice-actions">
        <b-card>
          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Print / Download
          </b-button>

          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            v-if="payments.payments.length === 0 && invoiceId.status < 2"
            @click="returnInvoice()"
          >
            Return Invoice
          </b-button>

          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mb-75"
            v-b-modal.modal-payment
            block
            v-if="payments.balance != 0 && invoiceId.status !== 3"
          >
            Add Payment
          </b-button>

          <!-- Documents -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mb-75"
            @click="handleInvoiceDocBtn(invoiceId.id)"
            block
          >
            Documents
          </b-button>

          <b-modal
            ref="modal-view-invoice-document"
            id="modal-view-invoice-document"
            ok-only
            ok-title="View"
            centered
            size="lg"
            title="View Documents"
            :hide-footer="true"
          >
            <DocumentUpload
              @deleteFile="deleteFile"
              @downloadFile="downloadFile"
              @uploadFiles="uploadFiles"
              :documentDetails="documentDetails"
            />
          </b-modal>

          <b-modal
            ref="signatureModalOpen"
            title="Digital Signature"
            hide-footer
            centered
          >
            <VueSignaturePad
              id="signature"
              width="100%"
              height="30vh"
              ref="signaturePad"
              style="border: 1px solid #ccc; background-color: #fff"
              :options="{
                onBegin: () => {
                  $refs.signaturePad.resizeCanvas();
                },
              }"
            />
            <div class="text-center mt-3">
              <b-button class="mr-1" @click="saveSignature" variant="success"
                >Save</b-button
              >
              <b-button class="mr-1" @click="undo" variant="warning"
                >Undo</b-button
              >
              <b-button @click="clearSignature" variant="danger"
                >Clear</b-button
              >
            </div>
          </b-modal>
          <!-- Documents -->

          <!-- Button: Add Delivery Note -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mb-75"
            v-b-modal.modal-delivery
            block
            v-if="productsDLL.length > 0 && invoiceId.status !== 3"
          >
            Schedule Delivery
          </b-button>

          <!-- View invoice rating -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mb-75"
            v-b-modal.modal-rating
            block
            v-if="this.invoiceId.rating !== null || this.invoiceId.rating > 0"
          >
            View Rating
          </b-button>

          <!-- <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="primary" class="mb-75" block
            @click="hideDiscount = !hideDiscount">
            {{ hideDiscount ? "Show Discount" : "Hide Discount" }}
          </b-button> -->

          <b-button
            v-if="this.vat"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            @click="hideVAT = !hideVAT"
          >
            {{ this.hideVAT ? "Show VAT" : "Hide VAT" }}
          </b-button>

          <b-button
            v-if="whenSelected.tel && tenant && invoiceId.status !== 3"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="info"
            class="mb-75"
            @click="openWhatsApp"
            block
          >
            <img src="@/assets/images/logo/whatsapp.png" class="w-10" />
            Whatsapp
          </b-button>

          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            @click="CompleteInvoice"
            v-if="
              payments.balance === 0 &&
              invoiceId.status !== 2 &&
              invoiceId.status !== 3
            "
          >
            Complete
          </b-button>

          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            v-if="invoiceId.status === 3"
            @click="showSignaturePad"
          >
            Signature
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-delivery"
      centered
      title="Schedule Delivery"
      hide-footer
      @hide="clearDelivery"
    >
      <b-form @submit.prevent="addDelivery">
        <b-row>
          <!-- username -->
          <b-col cols="12">
            <b-form-group label="Last Delivery Date" label-for="h-Date">
              <b-form-datepicker
                id="h-Date"
                placeholder="Choose a date"
                required
                v-model="deliveryDate"
                :min="minDate"
                :config="configDue.wrap"
                local="en"
                :initial-date="currentDate()"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Product" label-for="h-Date">
              <b-form-select
                id="h-Date"
                v-model="deliveryProduct"
                :options="productsDLL"
                required
              />
            </b-form-group>
          </b-col>

          <!-- email -->
          <b-col cols="12">
            <b-form-group label="Comments" label-for="d-Amount">
              <b-form-textarea
                id="d-Amount"
                v-model="deliveryNote"
                placeholder="Comments"
                required
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button variant="primary" type="submit">
              <b-icon icon="plus-circle"></b-icon>
              Schedule Delivery <b-spinner v-if="loadingNote"> </b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-modal id="modal-rating" centered title="Invoice Rating" hide-footer>
      <b-form>
        <b-row>
          <!-- rating -->
          <b-col cols="12">
            <b-form-group label="Rating" label-for="h-rating">
              <vue-star-rating
                v-model="invoiceId.rating"
                :star-size="30"
                :rating="rating"
                :increment="0.5"
                :read-only="true"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group label="Feedback" label-for="d-description">
              <b-form-textarea
                id="d-description"
                :value="feedbacks ? feedbacks.description || '' : ''"
                placeholder="Customer Feedback"
                disabled
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- {{ feedbacks }} -->
      </b-form>
    </b-modal>

    <!--- Modal Add Payment -->
    <b-modal id="modal-payment" centered title="Add Payment" hide-footer>
      <b-form @submit.prevent="addPayment">
        <b-row>
          <!-- username -->
          <b-col cols="12">
            <b-form-group label="Settlement Date" label-for="h-Date">
              <b-form-datepicker
                id="datepicker-placeholder"
                placeholder="Choose a date"
                required
                v-model="paymentDate"
                local="en"
                :initial-date="currentDate()"
              />
            </b-form-group>
          </b-col>

          <!-- email -->
          <b-col cols="12">
            <b-form-group label="Payment Amount" label-for="d-Amount">
              <b-form-input
                id="amount"
                :placeholder="currencySymbol"
                type="number"
                required
                min="0"
                step=".01"
                v-model="paymentAmount"
              />
              <span v-if="paymentAmount > payments.balance" class="text-danger"
                >Error: Payment amount is greater than payment balance</span
              >
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Payment Mode" label-for="d-PaymentMode">
              <b-form-select
                id="h-paymentMode"
                v-model="paymentMode"
                :options="paymentOptions"
                required
                @change="handleModeChange"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Reference" label-for="d-Reference">
              <b-form-input id="h-Reference" v-model="reference" />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button variant="primary" type="submit" :disabled="loading">
              <b-icon icon="plus-circle"></b-icon>
              Add Payment <b-spinner v-if="loading"> </b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <!-- View Signature Modal -->
    <b-modal
      title="View Signature"
      hide-footer
      centered
      ref="viewSignatureModalOpen"
      width="100%"
      height="30vh"
    >
      <!-- Display the saved signature -->
      <b-card class="text-center m-1">
        <!-- Responsive image -->
        <img
          :src="signatureData"
          alt="Digital Signature"
          class="img-fluid"
          style="
            border: 1px solid #ccc;
            background-color: #fff;
            max-height: 30vh;
            object-fit: contain;
          "
        />
      </b-card>
    </b-modal>
  </section>
</template>

<script>
import axios from "axios";
import {
  BRow,
  BModal,
  BCol,
  BCard,
  BCardBody,
  BFormSelect,
  BTable,
  BTableLite,
  BCardText,
  BFormGroup,
  BIcon,
  BFormInput,
  BFormCheckbox,
  BForm,
  BFormDatepicker,
  BButton,
  BAlert,
  BSpinner,
  BFormTextarea,
  BLink,
  VBToggle,
  BAvatar,
} from "bootstrap-vue";
import Logo from "@core/layouts/components/Logo.vue";
import Address from "@core/layouts/components/Address.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import { mapActions, mapGetters } from "vuex";
import html2pdf from "html2pdf.js";
import Ripple from "vue-ripple-directive";
import { fnSortingDropdown } from "@/libs/customFn";
import { CurrencySymbols } from "@/libs/defaultList";
import DocumentUpload from "@/views/component/DocumentUpload.vue";
import {
  deleteInvoiceDocument,
  uploadMultipleInvoiceDocuments,
  uploadInvoiceDocument,
  downloadInvoiceDocument,
} from "@/store/invoices/services";
import { customSwal, customError, customErrorMessage } from "@/libs/customFn";
import VueStarRating from "vue-star-rating";
import flatPickr from "vue-flatpickr-component";
import ClientAddress from "@/@core/layouts/components/ClientAddress.vue";

export default {
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  components: {
    BRow,
    BIcon,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BTable,
    BFormDatepicker,
    BForm,
    BFormTextarea,
    BFormSelect,
    BCard,
    BCardBody,
    BModal,
    BTableLite,
    BCardText,
    BButton,
    BSpinner,
    BAlert,
    Logo,
    BLink,
    Address,
    CompanyName,
    DocumentUpload,
    BAvatar,
    ClientAddress,
    VueStarRating,
    flatPickr,
  },
  data() {
    return {
      vat: JSON.parse(localStorage.getItem("userData")).vat,
      brn: JSON.parse(localStorage.getItem("userData")).brn,
      genSP: "",
      companyName: "",
      tenant: "",
      id: this.$route.params.id,
      salesPersonName: "",
      hideVAT: false,
      hideDiscount: false,
      whenSelected: [],
      paymentAmount: "",
      paymentDate: "",
      paymentMode: "",
      reference: "",
      deliveryDate: "",
      invoiceItemId: "",
      productImg: "",
      quantity: "",
      deliveryNote: "",
      deliveryProduct: "",
      signatureData: "",
      issuedDate: null,
      dueDate: null,
      products: [],
      whenSelected: [],
      rating: [],
      baseUrl: process.env.VUE_APP_MAIN_URL,
      fields: [
        {
          key: "productImg",
          label: "Product",
          formatter: (value, key, item) => {
            if (item.invoiceType === "Service") {
              return "";
            } else {
              if (item.itemId) {
                // Directly set the image src to the API endpoint
                let src = `${baseUrl}selfservices/getproductimage?ProductID=${item.itemId}`;
                console.log("src", src);
                return src;
              }
            }
          },
        },
        {
          key: "itemName",
          label: "Product Name",
          formatter: (value, key, item) => {
            if (item.invoiceType == "Service") {
              let serviceOrder = this.serviceOrderList.filter(
                (x) => x.id == item.serviceOrderId
              )[0];
              return `${serviceOrder.orderTemplateName} - ${serviceOrder.serviceReferenceNo}`;
            } else {
              return item.itemName;
            }
          },
        },
        {
          key: "description",
          label: "Description",
          formatter: (value, key, item) => {
            if (item.invoiceType == "Service") {
              let serviceOrder = this.serviceOrderList.filter(
                (x) => x.id == item.serviceOrderId
              )[0];
              return serviceOrder.orderTemplateName;
            } else {
              return item.description;
            }
          },
        },
        { key: "quantity", label: "Quantity" },
        {
          key: "price",
          label: "Unit Price",
          formatter: (value, key, item) =>
            `${this.currencySymbol} ${item.cost.toFixed(2)}`,
        },
        // { key: "discount", label: "Discount" },
      ],
      deliverynotes: [],
      // custom fields
      chosenFields: [],
      currencySymbol: "Rs",
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
      config: {
        wrap: {
          wrap: true,

          minDate: new Date(),
        },
      },
      configDue: {
        wrap: {
          wrap: true,

          minDate: new Date(),
        },
      },
      //feedbacks: [],
      paymentOptions: [
        { value: "CASH", text: "CASH" },
        { value: "CHEQUE", text: "CHEQUE" },
        { value: "ONLINEBANKTRANSFER", text: "ONLINEBANKTRANSFER" },
        { value: "CARD", text: "CARD" },
      ],
    };
  },
  computed: {
    minDate() {
      const today = new Date();
      return today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    },
    dynamicFields() {
      // Ensure baseFields is always an array
      let baseFields = [
        {
          key: "itemName",
          label: "Product Name",
          formatter: (value, key, item) => {
            if (item.invoiceType === "Service") {
              let serviceOrder = this.serviceOrderList.find(
                (x) => x.id == item.serviceOrderId
              );
              return serviceOrder
                ? `${serviceOrder.orderTemplateName} - ${serviceOrder.serviceReferenceNo}`
                : "";
            } else {
              return item.itemName;
            }
          },
        },
        {
          key: "description",
          label: "Description",
          formatter: (value, key, item) => {
            if (item.invoiceType === "Service") {
              let serviceOrder = this.serviceOrderList.find(
                (x) => x.id == item.serviceOrderId
              );
              return serviceOrder ? serviceOrder.orderTemplateName : "";
            } else {
              return item.description;
            }
          },
        },
        { key: "quantity", label: "Qty" },
      ];

      if (this.vat && !this.hideVAT) {
        baseFields.push({
          key: "vat",
          label: "VAT",
          formatter: (value, key, item) => {
            return item.tax ? `${item.tax} %` : "0 %";
          },
        });
      }

      baseFields.push({
        key: "price",
        label: "Unit Price",
        formatter: (value, key, item) =>
          `${this.currencySymbol} ${item.cost.toFixed(2)}`,
      });

      // Conditionally add productImg field if chosen
      if (this.isFieldChosen("ProductImage")) {
        baseFields.unshift({
          key: "productImg",
          label: "Product",
          formatter: (value, key, item) => {
            if (item.invoiceType === "Service") {
              return "";
            } else if (item.itemId) {
              // Directly set the image src to the API endpoint
              let src = `${this.baseUrl}selfservices/getproductimage?ProductID=${item.itemId}`;
              console.log("src", src);
              return src;
            }
            return "";
          },
        });
      }

      return baseFields;
    },
    getTotal() {
      if (this.hideVAT) {
        return this.invoiceId.subTotal;
      } else {
        return (
          this.invoiceId.total != undefined ? this.invoiceId.total : 0
        ).toFixed(2);
      }
    },

    errorMessage() {
      if (this.paymentAmount > this.payments.balance) {
        return "Error: Payment amount is greater than payment balance";
      } else {
        return "";
      }
    },

    ...mapGetters("tenantModule", {
      tenantFields: "tenantFields",
      signature: "signature",
      signatureid: "signatureid",
    }),
    ...mapGetters("selfserviceModule", {
      feedbacks: "feedbackId",
      loading: "loading",
    }),
    ...mapGetters("invoiceModule", {
      invoiceId: "invoiceId",
      documents: "documents",
      file: "file",
      loadingInvoice: "loading",
    }),
    ...mapGetters("productModule", {
      productList: "product",
      loading: "loading",
    }),
    ...mapGetters("customerModule", {
      custId: "custId",
      loading: "loading",
    }),
    ...mapGetters("leadModule", {
      leadList: "leads",
      leadId: "leadId",
      loadingCustomer: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("deliveryModule", {
      deliverynotesByInvoice: "deliverynotesByInvoice",
      deliveryNoteid: "deliveryNoteid",
      loadingNote: "loading",
    }),

    ...mapGetters("paymentModule", {
      payments: "payments",
      loading: "loading",
    }),
    ...mapGetters("serviceModule", {
      serviceOrderList: "serviceOrderList",
      loadingService: "loading",
    }),
    productsDLL() {
      return fnSortingDropdown(
        this.products.filter(
          (product) =>
            !this.deliverynotes.some(
              (delivery) => delivery.invoiceItemId === product.itemid
            )
        )
      );
    },
  },
  methods: {
    formatDate(timestamp) {
      return new Date(timestamp).toLocaleDateString("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    showSignaturePad() {
      if (this.signatureData) {
        this.$refs.viewSignatureModalOpen.show();
      } else {
        this.$refs.signatureModalOpen.show();
      }
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      if (!isEmpty) {
        //console.log("noteID", this.deliveryNoteID);
        let payload = {
          digitalSignature: data,
          moduleType: "Sales",
          reference: this.id,
        };
        console.log("payload", payload);
        this.addSignatureAction(payload)
          .then(() => {
            this.fetchSignature("Sales", this.$route.params.id);
            this.$refs.signatureModalOpen.hide();
          })
          .catch((error) => {
            console.error(error);
          });

        //todo add ModuleSignature api
      }
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },

    showNoImage(event) {
      // If the image fails to load, replace it with text "No Image"
      const parentElement = event.target.parentNode;
      if (parentElement) {
        parentElement.innerHTML = "<span>-</span>";
      }
    },
    async handleInvoiceDocBtn(referenceId) {
      try {
        await this.getInvoiceDocumentListAction(referenceId);
        if (this.documents.length > 0) {
          let loader = this.$swal({
            title: "Processing...",
            text: "Please wait while the document(s) is being featched",
            onOpen: () => {
              this.$swal.showLoading();
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
            buttonsStyling: false,
            showConfirmButton: false,
          });
          this.documentDetails.documentList = this.documents;
          this.documentDetails.isDelete = true;
          this.$swal.close();
        }
        this.$refs["modal-view-invoice-document"].show();
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },

    async downloadFile(id, fileName) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being prepared for download",
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadInvoiceDocument(id);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error("Download failed:", error);
        loader.close();
        this.error("Failed to download the file. Please try again."); // Updated error message for better clarity
      }
    },
    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document(s) is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      const referenceId = this.invoiceId.id;

      const maxSize = 20 * 1024 * 1024;
      if (this.selectedFiles && this.selectedFiles.size > maxSize) {
        alert("File size exceeds 20 MB limit. Please choose a smaller file.");
        this.submitting = false;
        return;
      }

      if (selectedFiles.length > 1) {
        await uploadMultipleInvoiceDocuments(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await uploadInvoiceDocument(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }
      await this.getInvoiceDocumentListAction(referenceId);
      this.documentDetails.isDelete = true;
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-invoice-document");
      });
    },

    async deleteFile(id) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being deleted",
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deleteInvoiceDocument(id)
        .then((response) => {
          loader.close();
          customSwal("Document deleted successfully!");
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getInvoiceDocumentListAction(this.invoiceId.id);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-invoice-document");
      });
    },

    customerSelected(id) {
      this.whenSelected = null;
      this.getLeadByIDAction(id)
        .then((response) => {
          this.whenSelected = this.leadId;
        })
        .catch((error) => {
          this.getCustomersByIDAction(id).then((response) => {
            this.whenSelected = this.custId;
          });
        });
    },

    beautifyDate(dateString) {
      const date = new Date(dateString);
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return date.toLocaleDateString("en-US", options);
    },

    openWhatsApp() {
      const message = `Please find attached the invoice for the recent transaction with ${this.companyName}. ${process.env.VUE_APP_CRM_URL}invoice/${this.tenant}/${this.id}`;
      const url = `https://web.whatsapp.com/send/?phone=${this.whenSelected.tel}&text=${message}&type=phone_number`;
      window.open(url, "_blank");
    },

    getDisable() {
      if (this.paymentAmount > this.payments.balance) {
        return true;
      } else {
        return false;
      }
    },
    ...mapActions("tenantModule", [
      "getTenantFCByModuleAction",
      "updateTenantFCAction",
      "addSignatureAction",
      "getSignatureByIDAction",
    ]),

    ...mapActions("selfserviceModule", ["getFeedbackIdAction"]),

    ...mapActions("invoiceModule", [
      "getInvoiceIdAction",
      "updateInvoicesAction",
      "returnInvoicesAction",
      "getInvoiceDocumentListAction",
    ]),
    ...mapActions("customerModule", ["getCustomersByIDAction"]),
    ...mapActions("leadModule", ["getLeadListAction", "getLeadByIDAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("paymentModule", [
      "getPaymentByIDAction",
      "addPaymentAction",
    ]),
    ...mapActions("productModule", ["getProductListAction"]),
    ...mapActions("deliveryModule", [
      "addDeliveryNotesAction",
      "getDeliveryNotesListAction",
      "getDeliveryNotesByIDAction",
      "getDeliverySignatureByIDAction",
    ]),
    ...mapActions("serviceModule", ["getServiceOrderListAction"]),
    // Check if a specific field is chosen
    isFieldChosen(key) {
      const result = this.chosenFields.some((field) => field.key === key);
      return result;
    },
    printInvoice() {
      window.print();
    },
    currentDate() {
      return new Date();
    },
    async viewSignature(id) {
      try {
        const filteredNotes = this.deliverynotesByInvoice.filter(
          (note) => note.id === id
        );

        if (filteredNotes.length > 0) {
          const foundNote = filteredNotes[0];
          const signature = foundNote.signature;

          if (signature) {
            this.signatureData = signature;
            this.$refs.viewSignatureModalOpen.show();
            this.IndexId = this.deliverynotesByInvoice.indexOf(foundNote);
          } else {
            swal({
              title: "No Signature Found",
              text: `No signature available for delivery note ID: ${id}`,
              icon: "warning",
              button: "OK",
            });
          }
        } else {
          console.error("Delivery note not found for ID:", id);
        }
      } catch (error) {
        console.error("Error fetching signature:", error);
      }
    },

    successAlert(transaction) {
      this.$bvToast.toast(`${transaction} Added Successfully`, {
        title: "Success",
        variant: "success",
        solid: true,
      });
      this.clearDelivery();
    },
    errorAlert(error) {
      this.$bvToast.toast(error.response.data.message, {
        title: "Error",
        variant: "danger",
        solid: true,
      });
    },
    error(msg) {
      this.$swal({
        title: "Error!",
        text: msg || "Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorDate() {
      this.$swal({
        title: "Error!",
        text: "Choose a delivery date!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    getProductName(id) {
      const product = this.productList.find((product) => product.id === id);
      return product ? product.name : "-";
    },

    getStatus(itemId){
      const status = this.deliveryNoteid
    },

    returnInvoice() {
      this.returnInvoicesAction(this.invoiceId.id)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Invoice has been returned",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.$router.push("/invoice/list");
        })
        .catch((error) => {
          customError(error);
        });
    },
    doComplete() {
      let payload = {
        id: this.invoiceId.id,
        leadClientId: this.invoiceId.leadClientId,
        salesPersonId: this.invoiceId.salesPersonId,
        orderId: this.invoiceId.orderId,
        discount: this.invoiceId.discount,
        dueDate: this.invoiceId.dueDate,
        subTotal: this.invoiceId.subTotal,
        issuedDate: this.invoiceId.issuedDate,
        currency: this.invoiceId.currency,
        tax: this.invoiceId.tax,
        total: this.invoiceId.total,
        notes: this.invoiceId.notes,
        status: 2,
        invoiceType: this.invoiceId.invoiceType,
        paymentMethod: this.invoiceId.paymentMethod,
        invoiceNo: this.invoiceId.invoiceNo,
        isActive: true,
        invoiceItem: this.invoiceId.invoiceItem,
      };
      this.updateInvoicesAction(payload)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Invoice completed successfully",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.$router.push("/invoice/list");
        })
        .catch((error) => {
          this.error(error);
        });
    },
    CompleteInvoice() {
      this.$swal({
        title: "Are you sure?",
        text: "You want to complete this invoice!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Complete it!",
        cancelButtonText: "No, cancel!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.doComplete();
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Invoice is not completed :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        }
      });
    },
    successDelivery() {
      this.$swal({
        title: "Delivery note Added!",
        text: "You have successfully added a delivery note!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    addDelivery() {
      let selected_item = this.invoiceId.invoiceItem.filter(
        (x) => x.itemId == this.deliveryProduct
      )[0];

      if (this.deliveryDate === null || this.deliveryDate === "") {
        //console.log("wbadcnsmco");
        this.errorDate();
        this.clearDelivery();
      } else {
        let payload = {
          invoiceId: this.id,
          itemId: this.deliveryProduct,
          invoiceItemId: selected_item.id,
          quantity: selected_item.quantity,
          deliveryDate: this.deliveryDate,
          note: this.deliveryNote,
          status: 0,
        };

        this.addDeliveryNotesAction(payload)
          .then(() => {
            this.successDelivery();
            window.location.reload();
            this.getInvoiceIdAction(this.id).then(() => {
              this.getSalesPersonListAction().then(() => {
                this.SalesPersonList.forEach((element) => {
                  if (element.id == this.invoiceId.salesPersonId) {
                    this.genSP = element.firstName + " " + element.lastName;
                  }
                });
              });
            });
            // this.paymentAmount = "";
            // this.paymentDate = "";
            this.$bvModal.hide("modal-delivery");
            this.getDeliveryNotesByIDAction(this.id).then(() => {
              this.deliverynotes = this.deliverynotesByInvoice;
            });
          })
          .catch(async (error) => {
            this.$bvModal.hide("modal-delivery");
            console.log(error);
            this.deliveryDate = "";
            this.deliveryNote = "";
            this.clearDelivery();
            this.errorAlert();
            await this.getDeliveryNotesByIDAction(this.id).then(() => {
              this.deliverynotes = this.deliverynotesByInvoice;
            });
            this.getInvoiceIdAction(this.id).then(() => {
              this.getSalesPersonListAction().then(() => {
                this.SalesPersonList.forEach((element) => {
                  if (element.id == this.invoiceId.salesPersonId) {
                    this.genSP = element.firstName + " " + element.lastName;
                  }
                });
              });
            });
          });
        this.clearDelivery();
      }
    },

    handleModeChange(newValue) {
      console.log("Selected Payment Mode:", newValue);
    },

    addPayment() {
      if (this.loading) return;
      this.loading = true;

      this.addPaymentAction({
        invoiceId: this.id,
        amountPaid: this.paymentAmount,
        settlementDate: this.paymentDate,
        paymentMode: this.paymentMode,
        reference: this.reference,
      })
        .then((response) => {
          this.successAlert("Payment");
          this.paymentAmount = "";
          this.paymentDate = "";
          this.paymentMode = "";
          this.reference = "";
          this.$bvModal.hide("modal-payment");
          this.getPaymentByIDAction(this.id);
          this.getInvoiceIdAction(this.id).then(() => {
            this.getSalesPersonListAction().then(() => {
              this.SalesPersonList.forEach((element) => {
                if (element.id == this.invoiceId.salesPersonId) {
                  this.genSP = element.firstName + " " + element.lastName;
                }
              });
            });
          });
        })
        .catch((error) => {
          this.$bvModal.hide("modal-payment");
          console.log(error);
          this.paymentAmount = "";
          this.paymentDate = "";
          this.errorAlert(error);
          this.getPaymentByIDAction(this.id);
          this.getInvoiceIdAction(this.id).then(() => {
            this.getSalesPersonListAction().then(() => {
              this.SalesPersonList.forEach((element) => {
                if (element.id == this.invoiceId.salesPersonId) {
                  this.genSP = element.firstName + " " + element.lastName;
                }
              });
            });
          });
        });
    },
    downloadInvoice() {
      var element = document.getElementById("invoice-preview-card");
      var opt = {
        margin: [0, 0],
        filename: "invoice.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      html2pdf().from(element).set(opt).save();
    },

    clearDelivery() {
      this.deliveryNote = "";
      this.deliveryProduct = "";
      this.deliveryDate = "";
    },
    async fetchSignature(moduleType, id) {
      try {
        const response = await this.getSignatureByIDAction({
          moduletype: moduleType,
          id: id,
        });
        if (response?.digitalSignature) {
          this.signatureData = response.digitalSignature;
        } else {
        }
      } catch (error) {
        console.error("Error fetching signature:", error);
        this.$swal(
          "Error",
          "Unable to fetch signature. Please try again.",
          "error"
        );
      }
    },
  },
  async mounted() {
    let loader = this.$swal({
      title: "Processing...",
      text: "Please wait while the Invoice is being updated",
      onOpen: () => {
        this.$swal.showLoading();
      },
      allowOutsideClick: () => !this.$swal.isLoading(),
      buttonsStyling: false,
      showConfirmButton: false,
    });
    try {
      await this.getProductListAction();
      await this.getServiceOrderListAction("SR_INVOICED");
      // this.getCustomersByIDAction(this.invoiceId.leadClientId);
      // this.getLeadByIDAction(this.invoiceId.leadClientId);
      await this.getDeliveryNotesByIDAction(this.id).then(() => {
        this.deliverynotes = this.deliverynotesByInvoice;
        console.log("deliverynotes", this.deliverynotes);
      });
      loader.close();
    } catch (e) {}
  },
  async beforeMount() {
    await this.getTenantFCByModuleAction("SalesInvoice").then(() => {
      // Assign the fields after the action is complete
      this.chosenFields = this.tenantFields.selectedFieldConfig;
      console.log("Chosen Fields:", this.chosenFields);
    });
    await this.getInvoiceIdAction(this.id)
      .then(() => {
        this.invoiceId.invoiceItem.forEach((element) => {
          if (element.invoiceType !== "Service") {
            this.products.push({
              value: element.itemId,
              text: element.itemName,
              itemid: element.id,
            });
          }
        });

        this.issuedDate = this.formatDate(this.invoiceId.createdOn);
        this.dueDate = this.formatDate(this.invoiceId.dueDate);
        this.getSalesPersonListAction().then(() => {
          this.SalesPersonList.forEach((element) => {
            if (element.id == this.invoiceId.salesPersonId) {
              this.genSP = element.firstName + " " + element.lastName;
            }
          });
        });
        // this.getDeliveryNotesListAction(this.id);

        this.companyName = localStorage.getItem("userTenant");
        this.tenant = localStorage.getItem("userTenant");

        if (this.invoiceId.currency == null) this.invoiceId.currency = "MUR";
        this.currencySymbol = CurrencySymbols[this.invoiceId.currency];

        this.getCustomersByIDAction(this.invoiceId.leadClientId)
          .then((response) => {
            this.whenSelected = this.custId;
          })
          .catch((error) => {
            this.getLeadByIDAction(this.invoiceId.leadClientId).then(
              (response) => {
                this.whenSelected = this.leadId;
              }
            );
          });

        this.getPaymentByIDAction(this.invoiceId.id);
      })
      .catch((response) => {
        console.log(response);
      });

    await this.getFeedbackIdAction(this.id);
    //await this.getSignatureByIDAction("Sales",this.id);
    await this.fetchSignature("Sales", this.$route.params.id);
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style scoped>
#signaturename {
  text-align: center;
  font-weight: bold;
  font-size: 1.2rem;
}

#signature {
  width: 100%;
  border: 0px;
  border-bottom: 0.5px solid black;
  height: 0.5px;
}
</style>
<style lang="scss">
@media print {
  a[href]:after {
    content: none !important;
  }

  // Global Styles
  html,
  body {
    height: 99% !important;
  }

  .invoice-date-title {
    color: black !important;
  }

  * {
    color: black !important;
  }

  body {
    background-color: transparent !important;
    font-size: 17.5px !important;
    color: black !important;
  }

  .flatpickr-input {
    font-size: 17.5px !important;
    color: black !important;
  }

  .content-header {
    display: none;
  }

  nav.header-navbar {
    display: none;
  }

  .main-menu {
    display: none;
  }

  .header-navbar-shadow {
    display: none !important;
  }

  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }

  footer.footer {
    display: none;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}

.no-margin-body .card-body {
  padding-left: 0;
  padding-right: 0;
}

.w-10 {
  width: 10%;
}
</style>
